const uint8ToBase64 = (arr: any) =>
  btoa(
    Array(arr.length)
      .fill("")
      .map((_, i) => String.fromCharCode(arr[i]))
      .join("")
  );

const importPublicKey = async (pem: string) => {
  const binaryDer = str2ab(pem.replace(/-----(BEGIN|END) PUBLIC KEY-----/g, "").replace(/\n/g, ""));
  return await window.crypto.subtle.importKey(
    "spki",  
    binaryDer,
    { name: "RSA-OAEP", hash: { name: "SHA-256" } },  
    true,  
    ["encrypt"]  
  );
};

const str2ab = (str: string) => {
  const binaryString = atob(str);
  const length = binaryString.length;
  const bytes = new Uint8Array(length);
  
  for (let i = 0; i < length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};

export default async function encrypt(obj: string, keyObj: { public_key: string }) {
  try {
    const publicKeyPem = keyObj.public_key;
    const publicKey = await importPublicKey(publicKeyPem);
    const enc = new TextEncoder();
    const encodedObj = enc.encode(obj);
    const encrypted = await globalThis.crypto.subtle.encrypt(
      { name: "RSA-OAEP" },
      publicKey,
      encodedObj
    );

    const encryptedArray = new Uint8Array(encrypted);
    const encryptedBase64 = uint8ToBase64(encryptedArray);

    return encryptedBase64;
  } catch (error) {
    throw new Error("Encryption failed", { cause: error });

  }
}
